import { CONDITIONS } from "@/lib/constants";
import { SHAPES, toothType, surfaceAt } from "./teeth";

const STROKE = "#94A3B8";
const POLYS = {
  top: "0,0 30,0 21,9 9,9",
  bottom: "9,21 21,21 30,30 0,30",
  left: "0,0 9,9 9,21 0,30",
  right: "30,0 30,30 21,21 21,9",
};

const fillOf = (c) => (CONDITIONS[c] || CONDITIONS.higido).color;

const Silhouette = ({ n, data, upper, onClick }) => {
  const shape = SHAPES[toothType(n)];
  const c = data.condition;
  const crownFill = ["canal", "implante", "extraido"].includes(c) ? "#FFFFFF" : fillOf(c);
  const rootFill = c === "canal" ? fillOf("canal") : c === "implante" ? fillOf("implante") : "#F8FAFC";
  return (
    <svg viewBox="0 0 40 64" className="h-14 w-9 cursor-pointer transition-transform duration-200 hover:-translate-y-0.5" onClick={onClick} data-testid={`tooth-body-${n}`}>
      <g transform={upper ? undefined : "translate(0 64) scale(1 -1)"} opacity={c === "extraido" ? 0.28 : 1}>
        {shape.roots.map((d, i) => <path key={i} d={d} fill={rootFill} stroke={STROKE} strokeWidth="1.2" />)}
        <path d={shape.crown} fill={crownFill} stroke={c === "higido" ? STROKE : "#475569"} strokeWidth="1.3" />
        {c === "implante" && [12, 17, 22, 27].map((y) => <line key={y} x1="13" x2="27" y1={y} y2={y} stroke="#065F46" strokeWidth="1" />)}
      </g>
      {c === "extraido" && (
        <g stroke="#E11D48" strokeWidth="2.6" strokeLinecap="round">
          <line x1="6" y1="10" x2="34" y2="54" /><line x1="34" y1="10" x2="6" y2="54" />
        </g>
      )}
    </svg>
  );
};

const Surfaces = ({ n, data, onSurface }) => (
  <svg viewBox="-1 -1 32 32" className="h-8 w-8" data-testid={`tooth-surfaces-${n}`}>
    {Object.entries(POLYS).map(([pos, pts]) => {
      const s = surfaceAt(n, pos);
      return (
        <polygon key={pos} points={pts} fill={data.surfaces?.[s] ? fillOf(data.surfaces[s]) : "#FFFFFF"} stroke={STROKE} strokeWidth="1"
          className="cursor-pointer transition-opacity hover:opacity-70" onClick={() => onSurface(s)} data-testid={`tooth-${n}-surface-${s}`} />
      );
    })}
    <rect x="9" y="9" width="12" height="12" fill={data.surfaces?.O ? fillOf(data.surfaces.O) : "#FFFFFF"} stroke={STROKE} strokeWidth="1"
      className="cursor-pointer transition-opacity hover:opacity-70" onClick={() => onSurface("O")} data-testid={`tooth-${n}-surface-O`} />
  </svg>
);

export const ToothGraphic = ({ n, data, upper, selected, onTooth, onSurface }) => {
  const num = (
    <span className={`font-mono-num text-[11px] font-semibold ${selected ? "rounded bg-sky-600 px-1 text-white" : "text-slate-500"}`}>{n}</span>
  );
  const body = <Silhouette n={n} data={data} upper={upper} onClick={() => onTooth(n)} />;
  const surf = <Surfaces n={n} data={data} onSurface={(s) => onSurface(n, s)} />;
  return (
    <div className={`flex flex-col items-center gap-1 rounded-xl px-0.5 py-1.5 transition-colors ${selected ? "bg-sky-50 ring-1 ring-sky-300" : "hover:bg-slate-50"}`} data-testid={`tooth-${n}`}>
      {upper ? <>{num}{body}{surf}</> : <>{surf}{body}{num}</>}
    </div>
  );
};
